export default "__VITE_ASSET__C2Fkr_sO__"